export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const USER_LOADED = 'USER_LOADED';
export const USER_LOADING = 'USER_LOADING';
export const AUTH_ERROR = 'AUTH_ERROR';

export const LOAD_ERRORS = 'LOAD_ERRORS';
export const MARK_ERROR_AS_SHOWN = 'MARK_ERROR_AS_SHOWN'